import { useEffect, useState } from 'react';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import moment from 'moment-jalali';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import Pagination from '../Common/Pagination';
import ReactInputMask from 'react-input-mask';

import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';

const SnappFood = () => {

    const { readData } = useEntityCrud('Report/GetTransaction_Snapfood');
    const { readData: readDataCompanies } = useEntityCrud('Branch/GetAllBranchs');

    const [rows, setRows] = useState([]);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [companies, setCompanies] = useState([]);
    const [companyId, setCompanyId] = useState(0);
    const [mobile, setMobile] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [fromAmount, setFromAmount] = useState('');
    const [toAmount, setToAmount] = useState('');
    const [searched, setSearched] = useState(false);
    const [count,setCount] = useState('0');

    useEffect(() => {
        readDataCompanies().then(({ data }) => {
            const companyList = data.result.map(company => ({
                label: company.title,
                value: company.id
            }))
            setCompanies(companyList)
        })
    },[])

    function convertToDate(date){
        if (!date)
            return "";
        return moment(`${date.year}/${date.month}/${date.day}`, 'jYYYY/jMM/jDD').format('jYYYY/jMM/jDD');
    }

    const calcPages = (res) => {
        let calcPages = res / 10;
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const getFilters = () => {
        const postedData = {
            p_limit: '10'
        };
        if(fromDate)
            postedData.p_fromdate = convertToDate(fromDate).replace(/\//g,'');
        if(toDate)
            postedData.p_todate = convertToDate(toDate).replace(/\//g,'');
        if(mobile)
            postedData.p_mobile = mobile.replace('-','');
        if(nationalCode)
            postedData.p_nationalcode = nationalCode;
        if(companyId)
            postedData.p_companyid = companyId.value.toString();
        if(fromAmount)
            postedData.p_fromamount = fromAmount;
        if(toAmount)
            postedData.p_toamount = toAmount;
        return postedData;
    }

    const getData = page => {
        const postedData = getFilters();
        postedData.p_offset = page ? page.toString() : currentPage.toString()
        readData(postedData).then(({ data }) => {
            if(data.status && data.result && data.result.v_result && data.result.v_result.length > 0){
                setRows(data.result.v_result);
                calcPages(data.result.v_count[0].cnt_total);
                setCount(data.result.v_count[0].cnt_total);
            }else{
                setRows([])
                setCount(0)
            }
        }).finally(() => {
            document.getElementById('get-data').classList.remove('btn-loading');
            setSearched(true);
        })
    }

    const submit = (e,page = null) => {
        document.getElementById('get-data').classList.add('btn-loading');
        setCurrentPage(1)
        getData(page);
    }

    const downloadExcel = () => {
        document.getElementById('get-excel').classList.add('btn-loading');
        const postedData = getFilters();
        postedData.excel_output = true;
        readData(postedData).then(({ data }) => {
            if(data.status)
                window.open(data.excelPath);
        }).finally(() => {
            document.getElementById('get-excel').classList.remove('btn-loading');
        })
    }

    const clearSearch = () => {
        setFromDate(null)
        setToDate(null)
        setCompanyId(0)
        setMobile('')
        setNationalCode('')
        setFromAmount('')
        setToAmount('')
        setSearched(false)
        setRows([])
    }

    const changePage = (e,page) => {
        setCurrentPage(page);
        getData(page);
    }

    const nextPage = () => {
        const page = currentPage + 1;
        setCurrentPage(page);
        getData(page);
    }

    const prevPage = () => {
        const page = currentPage - 1;
        setCurrentPage(page);
        getData(page);
    }

    const firstPage = () => {
        setCurrentPage(1);
        getData(1);
    }

    return (
        <div className="card">
            <div className="card-header"><div className="card-title">لیست تراکنش های اسنپ فود</div></div>
            <div className="card-body">
                <div className="row mb-4">
                    <div className="col-md-2 deskTopShow" style={{position: 'relative'}}>
                        <div className="form-group">
                            <label htmlFor="issueDate"> از تاریخ</label><br />
                            {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                            <DatePicker
                                name="p_fromdate"
                                required
                                locale="fa"
                                inputClassName={`form-control ${!fromDate && 'is-invalid'}`}
                                shouldHighlightWeekends
                                value={fromDate}
                                onChange={setFromDate}
                                className="form-control"
                                inputPlaceholder=' تاریخ  را انتخاب کنید ...'
                            />
                        </div>
                    </div>
                    <div className="col-md-2" style={{position: 'relative'}}>
                        <div className="form-group">
                            <label htmlFor="p_todate">تا تاریخ</label><br />
                            {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                            <DatePicker
                                name="p_todate"
                                required
                                locale="fa"
                                inputClassName={`form-control ${!toDate && 'is-invalid'}`}
                                shouldHighlightWeekends
                                value={toDate}
                                onChange={setToDate}
                                className="form-control"
                                inputPlaceholder='  تاریخ را انتخاب کنید ...'
                            />
                        </div>
                    </div>
                    <div className="col-md-2" style={{position: 'relative'}}>
                        <div className="form-group">
                            <label>شرکت زیر مجموعه</label>
                            {!!companyId && <i className="fe fe-x clear-select-btn" onClick={() => setCompanyId(0)}></i>}
                            <ReactSelect label="شرکت"
                                options={companies}
                                value={companyId}
                                onChange={e => setCompanyId(e)}
                                placeholder="انتخاب کنید"
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group mb-0">
                            <label>کد ملی</label>
                            <ReactInputMask mask="9999999999"
                                className="form-control ltr-input"
                                value={nationalCode}
                                onChange={e => setNationalCode(e.target.value)}
                            />
                        </div>
                    </div>
                    {/* <div className="col-md-2">
                        <div className="form-group mb-0">
                            <label>حداقل مبلغ تراکنش</label>
                            <input
                                className="form-control ltr-input"
                                value={fromAmount}
                                onChange={e => setFromAmount(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group mb-0">
                            <label>حداکثر مبلغ تراکنش</label>
                            <input
                                className="form-control ltr-input"
                                value={toAmount}
                                onChange={e => setToAmount(e.target.value)}
                            />
                        </div>
                    </div> */}
                    <div className="col-md-2">
                        <div className="form-group mb-0">
                            <label>شماره همراه</label>
                            <ReactInputMask mask="0\9999999999"
                                className="form-control ltr-input"
                                value={mobile}
                                onChange={e => setMobile(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6"/* style={{ marginTop: 30 }}*/>
                        <button className="btn btn-primary me-2" onClick={submit} id="get-data" disabled={!fromDate || !toDate}>جستجو</button>
                        <button className="btn btn-success me-2" onClick={downloadExcel} id="get-excel" disabled={!fromDate || !toDate}>دریافت خروجی اکسل</button>
                        {searched ? <button className="btn btn-danger" onClick={clearSearch} type="button">بازنشانی</button> : ''}
                    </div>
                </div>
                {searched && !rows.length && <div className="alert alert-info">تراکنشی یافت نشد</div>}
                {searched && rows.length && <div className="table-responsive">
                    <table className="table table-hover table-bordered">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>نام</th>
                                <th>کد ملی</th>
                                <th>شماره همراه</th>
                                <th>تاریخ</th>
                                <th>ساعت</th>
                                <th>مبلغ</th>
                                <th>شماره کارت</th>
                                <th>شرکت</th>
                                <th>وضعیت</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row,index) => <tr>
                                <td>{++index}</td>
                                <td>{row.fullname}</td>
                                <td>{row.nationalcode}</td>
                                <td>{row.mobile}</td>
                                <td>{row.trn_date ? `${moment(`${row.trn_date}`,'jYYYYjMMjDD').format('jYYYY-jMM-jDD')}` : '-'}</td>
                                <td>{row.trn_time || '-'}</td>
                                <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(row.amount)}</td>
                                <td dir="ltr">{row.pan_mask}</td>
                                <td>{row.company}</td>
                                <td>{row.status_desc}</td>
                            </tr>)}
                        </tbody>
                    </table>
                    <p>تعداد کل ردیف ها : {count || 0}</p>
                    <Pagination
                        changePage={changePage}
                        currentPage={currentPage}
                        pages={pages}
                        firstPageClick={firstPage}
                        lastPage={pages.length}
                        prevPageClick={prevPage}
                        nextPageClick={nextPage}
                    />
                </div>}
            </div>
        </div>
    )
}

export default SnappFood